
import { defineComponent, ref } from "vue";
import BaseLoader from "@/components/base/BaseLoader.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import PcIcon from "@/components/icons/PcIcon.vue";
import TsdIcon from "@/components/icons/TsdIcon.vue";
import { DESKTOP_TYPE, MOBILE_TYPE, TSD_TYPE } from "@/config/rates";

export default defineComponent({
  name: "BaseModal",
  components: { BaseLoader, PhoneIcon, PcIcon, TsdIcon },
  props: {
    title: {
      type: String,
      default: "Заголовок",
    },
    classname: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "Подзаголовок",
    },
    showFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRateDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    rateType: {
      type: Number,
      required: false,
      default: 0,
    },
    isRateActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const mobileType = ref(MOBILE_TYPE);
    const desktopType = ref(DESKTOP_TYPE);
    const tsdType = ref(TSD_TYPE);

    const hideModal = (e: any) => {
      const target: HTMLElement = e.target;
      if (target && target.className.includes("overlay")) {
        return emit("cancel");
      }
    };

    return {
      mobileType,
      desktopType,
      tsdType,
      hideModal,
    };
  },
});
